import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'S-Button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  readonly label = input<string>();
  readonly color = input<'white' | 'black'>('white');
  readonly size = input<'xs' | 'sm' | 'md' | 'lg'>('md');
  readonly arrow = input<'right' | 'bottom' | 'top'>('right');
  readonly disabled = input<boolean>(false);
  readonly ariaLabel = input<string>();

  readonly click = output<void>();

  getSizeClasses(): string {
    switch (this.size()) {
      case 'xs':
        return 'text-xs py-1 ';
      case 'sm':
        return 'text-sm py-1.5 ';
      case 'lg':
        return 'text-lg py-2.5 ';
      case 'md':
      default:
        return 'text-base py-2 ';
    }
  }
  getIconSize(): { width: number; height: number } {
    switch (this.size()) {
      case 'xs':
        return { width: 16, height: 16 };
      case 'sm':
        return { width: 20, height: 20 };
      case 'lg':
        return { width: 28, height: 28 };
      case 'md':
      default:
        return { width: 24, height: 24 };
    }
  }
  getArrowPath(): string {
    switch (this.arrow()) {
      case 'bottom':
        return 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.59-5.58L4 12l8 8 8-8z';
      case 'top':
        return 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.59 5.58L20 12l-8-8-8 8z';
      case 'right':
      default:
        return 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z';
    }
  }
  getButtonClasses(): string {
    const baseClasses = 'flex cursor-pointer flex-row items-center';
    const disabledClasses = this.disabled()
      ? 'opacity-50 cursor-not-allowed pointer-events-none'
      : '';
    return `${baseClasses} ${disabledClasses}`.trim();
  }

  onButtonClick(): void {
    if (!this.disabled()) {
      this.click.emit();
    }
  }
}
